export default __webpack_public_path__ + "static/media/excel2021.8949e811.svg";